export enum ProcessingStatus {
  DRAFT = 'draft',
  QUEUED = 'queued',
  STARTED = 'started',
  FAILED = 'failed',
  COMPLETED = 'completed'
}